import { ProgrammeCTAType } from "@customTypes/ProgrammeCTAType";
import { useSettings } from "@utilities/context/settings";

export const useApplicationLink = ({
  user,
  programmeApplyOnlineId,
  isSalesforceApplication,
}: {
  user: boolean;
  programmeApplyOnlineId: string;
  isSalesforceApplication?: boolean;
}) => {
  const { siteSettings } = useSettings();
  return getApplicationLink({user, programmeApplyOnlineId, isSalesforceApplication, siteSettings});
};

export const getApplicationLink = ({
  user,
  programmeApplyOnlineId,
  isSalesforceApplication,
  siteSettings,
}: {
  user: boolean;
  programmeApplyOnlineId: string;
  isSalesforceApplication?: boolean;
  siteSettings: ReturnType<typeof useSettings>["siteSettings"];
}) => {
  const interactUrl = !(programmeApplyOnlineId=="")?`/interact?applyID=${programmeApplyOnlineId}`:"/interact";
  const salesforceUrl = `${process.env.NEXT_PUBLIC_SALESFORCE_URL}/applicant/s?applyID=${programmeApplyOnlineId}`;
  const apply = siteSettings?.programmeCtaPagesCollection?.items.filter(
    ({ type }) => type === ProgrammeCTAType.Apply
  )[0];

  if (!user) {
    return `${apply?.url.slug}?applyID=${programmeApplyOnlineId}&isSalesforceApplication=${isSalesforceApplication}`;
  } else return isSalesforceApplication?salesforceUrl:interactUrl;
};

/* This is doing the check at the button click. 
   Another check has been implemented on the Interact page so it is not necessary to call this anymore.
   Keep the function here in case need to call it in furture */
export const handleApplyClick = async (
  _e:
    | React.MouseEvent<HTMLAnchorElement>
    | React.KeyboardEvent<HTMLAnchorElement>,
  applyNowUrl: string
) => {
  if (!applyNowUrl.includes("interact")) {
    window.location.href = `/${applyNowUrl}`;
    return;
  }
  try {
    const res = await fetch("/api/interactHealth");
    const targetUrl = res.ok ? applyNowUrl : `/crmmaintenancepage`;

    window.location.href = targetUrl;
  } catch {
    window.location.href = `/crmmaintenancepage`;
  }
};
